module.exports = __webpack_public_path__ + "assets/img/326101.e78ef5ef.svg";